<template>
	<div>
	

	</div>
</template>

<script>
	import left from './shared/left-nav'
	
	export default {
		name: 'App',

		data() {
			return {
			}
		},
		components: {
			appLeft: left,
		},
		methods:{
			
		}
		
		
	}
</script>


// WEBPACK FOOTER //
// src/components/website/index.vue